import mustache from 'mustache';
import { price_display_template } from "./templates";
import { InstantBookSettings, vehicleTypeID } from "../util/type_defs";
import { add_membership, get_customer_memberships, get_customer_token, get_reserve_quote, get_spots_availability } from "./instantBook_api";
import { ConfirmAndPayModalDisplay } from './instantBook_ui_scripts';


export function handle_instant_book_form_submit(event:Event) {
    event.preventDefault();
    let form:HTMLFormElement = this;
    const feedback_el:HTMLElement = this.querySelector("[feedback-el]");

    const settings:InstantBookSettings|null = get_reserve_settings(form);

    if (settings == null) return;

    form.querySelector("[submitInstantBook]").innerHTML = '<div class="spinner-border" role="status"></div>';
    get_spots_availability(settings).then((result) => {
        setTimeout(() => {
            form.querySelector("[submitInstantBook]").innerHTML = "Check availability";
        }, 500);
        feedback_el.innerHTML = "";
        let vehicleValid:boolean = check_vehicle_valid();
        if (!(vehicleValid)) {
            vehicleValid = setVehicle();
        };
        let available_spots:Record<string,string> = {};
        for (let i:number = 0; i < result.spots.length; i++) {
            if (result.spots[i].available) {
                available_spots[result.spots[i].id] = result.spots[i].price;
            }
        };

        if (Object.keys(available_spots).length == 0) {
            $("#no_spots_disp").show();
        } else {
            $("#no_spots_disp").hide();
        };

        $("#s2n_spots_list").find("[spot_id]").each(function(i,el) {
            try {
                const spot_id:string = el.getAttribute("spot_id");
                if (spot_id in available_spots) {
                    el.querySelector("[price]").setAttribute("rate", available_spots[spot_id]);
                    el.querySelector("[price]").innerHTML = mustache.render(price_display_template,{price:available_spots[spot_id]});
                    if (vehicleValid) {
                        $(el.querySelector("[view-add-vehicle]")).hide();
                        $(el.querySelector("[add-to-cart]")).show();
                    } else {
                        $(el.querySelector("[view-add-vehicle]")).show();
                        $(el.querySelector("[add-to-cart]")).hide();
                    };
                    $(el).show();
                } else {
                    $(el).hide();
                    el.querySelector("[price]").innerHTML = "";
                    $(el.querySelector("[add-to-cart]")).hide();
                }
            } catch {

            };
        });
    $('#leftContainercomponents').addClass("d-none");
    $('#cgCardReserve').removeClass("d-none");
    $(".showCampInfoBtn").removeClass("d-none");
    }).catch(e => {
        setTimeout(() => {
            form.querySelector("[submitInstantBook]").innerHTML = "Check availability";
        }, 500);
        feedback_el.innerHTML = e.message;
    });
};

export function init_checkout(customer_token:string,is_tripPlanner:boolean) {

    $("#reservationConfirmation").html("");
    $("#reserveOffcanvas").offcanvas("hide");

    const settings:InstantBookSettings = get_reserve_settings(document.getElementById("instantBookForm") as HTMLFormElement);

    const spot_id:number = window.spotId;

    $("#quoteDisp").html("");
    $("#quoteDispNew").html("");
    get_customer_memberships().then(membershipsHTML => {
        $("#customerMembershipsDisp").html(membershipsHTML);
    });
    get_reserve_quote(spot_id, settings).then(quoteDispHTML => {
        // $("#quoteDisp").html(quoteDispHTML);
        $("#quoteDispNew").html(quoteDispHTML);
        
        $("#checkoutOffcanvasImg").css("background-image", $("#confirmandpaymodalImg").css("background-image"));
        const iframe:HTMLElement = document.createElement("iframe");
        iframe.setAttribute("src", `https://bookings.spot2nite.com/customers/${customer_token}/payment-methods`);
        iframe.style.minHeight = "255px";
        $("#paymentMethod").html(iframe);
        $("#completeCheckout").removeClass("disabled");
        // $("#checkoutOffcanvas").offcanvas("show");
        ConfirmAndPayModalDisplay(spot_id.toString());
        if(is_tripPlanner) {
            $("#cgCardReserve").addClass("d-none");
            $("#cgCardCheckout").removeClass("d-none");
            $("#checkoutHeader").removeClass("d-none");
            $("#instantBookForm").addClass("d-none");
            $("#addCredentialsLink").off("click");
            $("#addCredentialsLink").on("click",function(event) {
                event.preventDefault();
                $("#addCredentialsLink").addClass("d-none");
                $("#discountfield").removeClass("d-none");

                $("form[addmembershipform]").off("submit");
                $("form[addmembershipform]").on("submit", function(event) {
                    event.preventDefault();
                    const membershipType:string = $(this).attr("membershipType");
                    const membershipId:string = $(this).find(`#input-${membershipType}`).val().toString();

                    add_membership(membershipType, membershipId).then(membershipDisplayHtml => {
                        $("#noMembershipsDisp").remove();
                        $("#customerMembershipsDisp").prepend(membershipDisplayHtml);
                    }).catch(e => {
                        console.error(e);
                    });
                });
            });
        } else {
            $("#confirmandpay_modal").modal("show");
        };
    }).catch(e => {
        $("#checkoutErrDisp").html(e.message);
        $("#checkoutErrModal").modal("show");

        setTimeout(() => {
            // $("#checkoutOffcanvas").offcanvas("hide");
            $("#confirmandpay_modal").modal("hide");
        }, 1000);
    });
};

function check_vehicle_valid() {
    if (window.vehicle == undefined) return false;
    const len = window.vehicle.length;
    const type = window.vehicle.type;
    return (!Number.isNaN(len)) && (type.length > 0);
};

export function get_reserve_settings(form:HTMLFormElement):InstantBookSettings|null {
    const feedback_el:HTMLElement = form.querySelector("[feedback-el]");

    const selectedDates:Date[] = window.instantBoook_Date_pickr.selectedDates;

    if (selectedDates.length < 2) {
        feedback_el.innerHTML = "Select Check-in and Check-out Dates";
        return null;
    };

    const parkId_el:HTMLInputElement = form.querySelector("input[name='parkId']");
    const parkId:number = parseInt(parkId_el.value);

    if (window.vehicle == undefined) {
        setVehicle();
    };
    if (window.guests == undefined) {
        setGuests();
    };

    const settings:InstantBookSettings = {
        parkId: parkId,
        dates:selectedDates,
        vehicleType:window.vehicle.type,
        vehicleLength:window.vehicle.length,
        slideouts: {
            driver: window.vehicle.d_slide,
            passenger: window.vehicle.p_slide,
            rear: window.vehicle.r_slide
        },
        guests: window.guests
    };

    return settings;
};

export function setGuests() {
    let start_state:string|undefined;
    if (window.guests == undefined) start_state = undefined;
    else start_state = JSON.stringify(window.guests);

    const form:HTMLElement = document.getElementById("instantBookForm");

    if (form == undefined) {
        return;
    };

    const n_adults_el:HTMLInputElement = form.querySelector("#adults");
    const n_children_el:HTMLInputElement = form.querySelector("#children");
    const n_infants_el:HTMLInputElement = form.querySelector("#infants");
    const n_pets_el:HTMLInputElement = form.querySelector("#pets");


    const n_adults:number = parseInt(n_adults_el.value);
    const n_children:number = parseInt(n_children_el.value);
    const n_infants:number = parseInt(n_infants_el.value);
    const n_pets:number = parseInt(n_pets_el.value);

    window.guests = {
        adults: n_adults,
        children: n_children,
        infants: n_infants,
        pets: n_pets
    };

    return JSON.stringify(window.guests) != start_state;
};

export function setVehicle() {
    let start_state:string|undefined;
    if (window.vehicle == undefined) start_state = undefined;
    else start_state = JSON.stringify(window.vehicle);

    const form:HTMLElement = document.getElementById("instantBookForm");

    if (form == undefined) {
        return;
    }

    const RV_class_input:HTMLSelectElement = form.querySelector("#cust-rv-class");
    const RV_length_input:HTMLInputElement = form.querySelector("#rv-length");
    const d_slideout_el:HTMLInputElement = form.querySelector("#driver-slideout");
    const p_slideout_el:HTMLInputElement = form.querySelector("#passenger-slideout");
    const r_slideout_el:HTMLInputElement = form.querySelector("#rear-slideout");

    const RV_class:vehicleTypeID|"" = RV_class_input.value as vehicleTypeID|"";
    const RV_length:number = parseInt(RV_length_input.value);
    const driver_slideout:boolean = d_slideout_el.checked;
    const passenger_slideout:boolean = p_slideout_el.checked;
    const rear_slideout:boolean = r_slideout_el.checked;

    window.vehicle = {
        type:RV_class,
        length:RV_length,
        d_slide:driver_slideout,
        p_slide:passenger_slideout,
        r_slide:rear_slideout
    };

    if (check_vehicle_valid()) {
        console.log("vehicle valid");
        $("#s2n_spots_list").find("[spot_id]").each(function(i,el) {
            if ($(el).is(":visible")) {
                if ($(el).find("[view-add-vehicle]").is(":visible")) {
                    $(el).find("[view-add-vehicle]").hide();
                    $(el).find("[add-to-cart]").show();
                };
            };
        });
    }

    return JSON.stringify(window.vehicle) != start_state;
};